import { getInitialDotsWidth, getLastDotsWidth, getDotsWidth } from 'components/UI/Slider/utils';

export function getDotWidth(length, current, i) {
  // if five or less slides, then dots have default width of 30 px
  if (length <= 5) return 'defaultWidth';

  // width of first five dots at the start of a slider
  if (current < 3) {
    return getInitialDotsWidth(i);
  }

  // width of dots in the middle of a slider
  if (current > length - 4) {
    return getLastDotsWidth(i, length - 4);
  }

  // width of last five dots in a slider
  if (current >= 3) {
    return getDotsWidth(i, current);
  }

  // return dots, that are not covered by previous condition checks, with default width
  return 'defaultWidth';
}

export function getActiveCardWidth() {
  const cardsWrapperWidth = document.getElementById('cardsWrapper').getBoundingClientRect().width;
  const cardWidth = window.innerWidth > 1024 ? 18 : 23;
  const activeCardWidth = (cardsWrapperWidth * cardWidth) / 100;

  return activeCardWidth;
}
